import React, { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { PencilFill, PlusCircleFill } from 'react-bootstrap-icons';
import PredioForm from './PredioForm';
import { Predio } from '../../../service/types/types';

interface PredioModalProps {
  predio?: Predio;
  onSaved: () => void;
}

export default function PredioModal({ predio, onSaved }: PredioModalProps) {
  const [show, setShow] = useState(false);
  const isEditing = !!predio;

  const handleSaved = () => {
    setShow(false);
    onSaved();
  };

  return (
    <>
      <Button size="sm" variant={isEditing ? 'outline-primary' : 'light'} onClick={() => setShow(true)}>
        {isEditing ? (
          <>
            <PencilFill className="me-1" /> Editar
          </>
        ) : (
          <>
            <PlusCircleFill className="me-1" /> Crear Predio
          </>
        )}
      </Button>
      <Modal show={show} onHide={() => setShow(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>{isEditing ? 'Editar Predio' : 'Nuevo Predio'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <PredioForm predio={predio} onSaved={handleSaved} onCancel={() => setShow(false)} />
        </Modal.Body>
      </Modal>
    </>
  );
}
